<template>
  <v-row justify="center">
    <v-dialog persistent :max-width="cm_width" :value="cm_dialog">
      <v-card>
        <v-card-title class="headline"> {{ cm_title }} </v-card-title>
        <v-card-text>{{ cm_text }}</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            :outlined="cm_outlined"
            :color="cm_color"
            @click="$emit('done', false)"
            dark
            class="text-capitalize"
          >
            {{ cm_textBtn }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
export default {
  name: "completeDialog",
  props: {
    cm_dialog: Boolean,
    cm_title: {
      type: String,
      default: "Successfully Saved",
    },
    cm_outlined: {
      type: Boolean,
      default: false,
    },
    cm_color: {
      type: String,
      default: "success",
    },
    cm_text: {
      type: String,
      default: "",
    },
    cm_width: {
      type: String,
      default: "400",
    },
    cm_textBtn: {
      type: String,
      default: "Done",
    },
  },
};
</script>

<style></style>
